<template>
    <b-modal ref="profile_modal"
             size="lg"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>

        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">ID:{{this.item.id}}</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">

                <b-overlay :show="is_load" rounded="sm">

                    <div class="panel-content">
                        <div class="d-flex flex-column align-items-center justify-content-center p-4">
                            <h5 class="mb-0 fw-700 text-center mt-3">
                                {{this.item.title}}
                                <small class="text-muted mb-0">
                                    {{__t('ACTION_INFO')}}
                                </small>
                            </h5>
                        </div>

                        <div>
                            <b-tabs content-class="mt-3">
                                <b-tab v-for="(tab,index) in tabs" @click="set_active(index)" :title="get_tab_title(tab)" :key="index" :active="tab.is_active">
                                    <template slot="title">
                                        {{get_tab_title(tab)}}
                                        <b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
                                    </template>
                                    <component @on_change_attribute="on_change_attribute" v-bind:is="tab.index" :action="item"></component>
                                </b-tab>
                            </b-tabs>
                        </div>
                        <div>
                        </div>
                    </div>

                </b-overlay>
            </div>
            <!--FOOTER -->
        </div>

        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                <button type="button" @click="remove(false)" class="btn btn-outline-danger waves-effect waves-themed mr-5 pl-5 pr-5" v-if="item_id > 0">
                    {{ __t('REMOVE') }}
                </button>

                <button type="button" @click="close()" class="btn btn-secondary waves-effect waves-themed">
                    {{ __t('CLOSE') }}
                </button>

                <button type="button" v-on:click="save_item" class="btn btn-primary waves-effect waves-themed">
                    {{ __t('SAVE') }}
                </button>
            </div>
        </template>
    </b-modal>
</template>



<script>

import action_info from "./tabs/action_info.vue";
import action_schedule from "./tabs/action_schedule.vue";
import action_params from "./tabs/action_params.vue";
import action_cart_rule from "./tabs/action_cart_rule.vue"
import action_codes from "./tabs/action_codes.vue";

export default {
    name: "action_modal",
    props : {
        modal_position : {
            type : String,
            default : "right"
        },
    },

    components : {
        action_info,
        action_schedule,
        action_params,
        action_cart_rule,
        action_codes
    },

    data() {
        return {
            item_id : 0,
            group_id : 0,
            item: {
                "id" : 0,
                "title" : "",
                "cart_title" : "",
                "price" : 0,
                'group_id' : 0,
                'published' : 1,
                'is_multiple' : false,
                "times" : [],
                'active_group' : {
                    "id" : 0,
                    'type' : ""
                },
                "action_products" : [],
                promo_codes: [],
            },
            is_load: false,
            is_show_modal: false,
            tabs : []
        }
    },

    created () {
        EventBus.$on("action_edit", this.work_click);
        EventBus.$on("action_close",this.close);
    },

    methods : {
        work_click(_id,group_id) {
            this.item_id = _id;
            this.group_id = group_id;

            this.is_show_modal = true;
            this.load_action();
        },

        on_change_attribute(atr_name,atr_val) {

            console.log('change_atr',atr_name,atr_val);

            if(this.item.hasOwnProperty(atr_name)) {
                this.item[atr_name] = atr_val;
                this.$set(this.item,atr_name,atr_val);
            }

            if (atr_name === 'is_multiple' || atr_name === 'promo_codes') {
                this.$nextTick(() => {
                    this.push_tabs();
                });
            }
        },

        get_tab_title (tab) {
            if(tab.count > 0) {
                return tab.title;
            }
            return tab.title;
        },

        set_active (obj) {
            for (let tab in this.tabs) {
                this.tabs[tab].is_active = false;
            }

            this.tabs[obj].is_active = true;
            EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
        },

        async load_action () {
            this.is_load = true;

            this.tabs = [];
            await api.get('/internal/v1/catalog/pwa/actions/' + parseInt(this.item_id)).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.item = data.data;
                    if(parseInt(this.item_id) === 0) {
                        this.item.group_id = this.group_id;
                    }
                    this.load_groups();

                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,position : "b-toaster-top-left"})
            });
        },

        async load_groups() {
            this.groups = [];
            this.is_load = true;

            await api.get('/internal/v1/catalog/pwa/actions/groups').then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.groups = data.data;

                    //Push In Action group
                    this.item.active_group = {
                        "id" : 0,
                        'type' : ""
                    };

                    this.groups.map(group => {
                        if(parseInt(this.item.group_id) === parseInt(group.id)) {
                            this.item.active_group = group;
                        }
                    });

                    this.push_tabs();
                }
            }).catch(({response}) => {
                this.push_tabs();
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },


        async remove(is_force) {
            let self = this;
            const is_ok = confirm_me(this.__t("ARE_SURE"));
            is_ok.then(res => {
                self.is_load = true;
                api.delete('/internal/v1/catalog/pwa/actions/'+ parseInt(this.item.id)).then(({data}) => {
                    self.is_load = false;
                    if (data.status === "operation_success") {
                        window.location.reload();
                    }
                }).catch(({response}) => {
                    self.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message, type: "danger",
                        title: response.data.status,
                        position : "b-toaster-top-left"
                    })
                });
            });
        },

        async save_item() {
            this.is_load = true;
            await api.put('/internal/v1/catalog/pwa/actions/'+ parseInt(this.item.id),this.item)
                .then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        EventBus.$emit("action_close");
                        EventBus.$emit("reload_actions");
                    }
                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status,
                        position : "b-toaster-top-left",
                    })
                });
        },

        close () {
            this.item = {
                "id" : 0,
                "title" : "",
                "cart_title" : "",
                "price" : 0,
                'group_id' : 0,
                'published' : 1,
                'is_multiple' : false,
                "times" : [],
                'active_group' : {
                    "id" : 0,
                    'type' : ""
                },
                promo_codes: [],
            };

            this.item_id  = 0;
            this.group_id = 0;

            this.tabs = [];
            this.is_show_modal = false;
        },



        push_tabs() {
            let activeIndex = null;

            let oldActive = this.tabs.find(tab => tab.is_active);
            if (oldActive) {
                activeIndex = oldActive.index;
            }

            this.tabs = this.default_tabs.map((item, index) => {
                return {
                    title: item.title,
                    is_active: activeIndex
                        ? item.index === activeIndex
                        : index === 0,
                    is_load: false,
                    index: item.index,
                };
            });
        },
    },

    computed : {
        default_tabs() {
            let group_type = this.item.active_group.type;

            try {
                if (group_type == 'catalog') {
                    return this.filter_tabs.filter(tab => {
                        return tab.index != 'action_cart_rule';
                    });
                }
            }
            catch (e) {
                console.log(e);
            }


            return this.filter_tabs;
        },

        filter_tabs() {
            let base = [
                {
                    title: this.__t('MAIN_SETTINGS'),
                    index: "action_info",
                    is_active: true,
                },
                {
                    title: this.__t('PWA.ACTION.PARAMS'),
                    index: "action_params",
                    is_active: false,
                },
                {
                    title: this.__t('PWA.CART_RULES'),
                    index: "action_cart_rule",
                    is_active: false,
                },
                {
                    title: this.__t('SCHEDULE'),
                    index: "action_schedule",
                    is_active: false,
                },
            ];

            let group_type = this.item?.active_group?.type || '';

            console.log('filter_tabs', group_type, this.item.is_multiple);

            if (group_type === 'promo' && this.item.is_multiple) {
                base.push({
                    title: this.__t('PROMO_CODES') +  '('+ this.item.promo_codes.length + ")",
                    index: "action_codes",
                    is_active: false,
                });
            }

            return base;
        },


        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-lg";
            }

            return "modal-dialog-right modal-lg";
        },
    }
}
</script>


<style scoped>

</style>
